import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {Object} from 'es6-shim';
import {diff} from 'deep-object-diff';
import {IClassiDocumentali, IUser} from '../../../../commons/interfaces/user/user';

interface IUserT {
  email: string;
  piva: string;
  codice_fiscale: string;
  company_name: string;
  _id: string;
  classiDocumentali: IClassiDocumentali;
}

class GestioneClassiDocumentaliController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      usersList: IUserT[],
      user: IUserT,
      classi: { name: string, value: boolean }[]
      originalUsers: IUser[],
      getUsersTypeaheadValues: () => void,
      filtroScadenza: string[]
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    // $scope.entries = Object.entries;
    $scope.pageHeader = 'Gestione Classi Documentali';
    $scope.pageSubHeader = 'Scegli l\'utente per la gestione delle classi documentali';
    $scope.user = undefined;
    $scope.classi = undefined;
    $scope.usersList = [];
    $scope.filtroScadenza = [];
    let anagrafica = [] as IUserT[];
    $rootScope.formsubmitted = false;

    $scope.filterScaduti = () => {
      $scope.usersList = anagrafica.filter(item => {
        const ragSociale = item.company_name.toLowerCase().includes($scope.filtroScadenza[0] && $scope.filtroScadenza[0].toLowerCase() || '');
        const piva = item.piva.toLowerCase().includes($scope.filtroScadenza[1] && $scope.filtroScadenza[1].toLowerCase() || '');
        const codice_fiscale = item.codice_fiscale.toLowerCase().includes($scope.filtroScadenza[3] && $scope.filtroScadenza[3].toLowerCase() || '');
        const email = item.email.toLowerCase().includes($scope.filtroScadenza[2] && $scope.filtroScadenza[2].toLowerCase() || '');
        return ragSociale && piva && codice_fiscale && email;
      });
    };

    $scope.setClassi = async (id) => {
      const classiDisponibili = JSON.parse(JSON.stringify(await ArchiSmallServices.getClassiDocumentali())) as IClassiDocumentali;
      $scope.user = anagrafica.find(item => item._id === id);
      $scope.classi = Object.entries({...classiDisponibili, ...$scope.user.classiDocumentali})
        .map(([n, v]: [string, boolean]) => {
          let classe = n.toUpperCase().split('_').join(' ');
          if (classe === 'LIBRO REGISTRI IVA') {
            classe = 'REGISTRI IVA';
          }
          if (classe === 'PRIMA NOTA') {
            classe = 'REGISTRO PRIMA NOTA';
          }
          if (classe === 'REGISTRO RIFIUTI') {
            classe = 'REGISTRO CARICO SCARICO RIFIUTI';
          }
          return {
            name: classe,
            value: v
          };
        })
        .sort(({name: a}, {name: b}) => a.localeCompare(b));
    };

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };


    $scope.getUsersTypeaheadValues = () => {
      ArchiSmallServices.getUsers()
        .then((response) => {

          $scope.originalUsers = JSON.parse(JSON.stringify(response)) as IUser[];

          anagrafica = (JSON.parse(JSON.stringify(response)) as IUser[]).reverse().map(item => {
            return {
              email: item.accountData.email,
              piva: item.organizationData.PIVA,
              codice_fiscale: item.organizationData.fiscalCode,
              company_name: item.organizationData.name ||
                (item.organizationData.contactPerson.firstname + ' ' + item.organizationData.contactPerson.surname),
              _id: item._id,
              classiDocumentali: item.classiDocumentali
            };
          }).sort(({company_name: a}, {company_name: b}) => a.localeCompare(b));
          // response.unshift({email: 'create_all_accounts@archismall.it', piva: 'Tutti utenti',
          //   company_name: 'Tutti utenti', _id: '-'});
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getUsersTypeaheadValues();

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.openConfermaModal = (size) => {
      // console.log(originalUsers);

      // console.log('originale', $scope.users.user);

      const user = $scope.originalUsers.find(user => {
        return user._id === $scope.user._id;
      });

      user.classiDocumentali = $scope.classi.map(classe => {
        const obj = {};
        let nome = classe.name.split(' ').join('_').toLowerCase();
        if (nome === 'registri_iva') {
          nome = 'libro_registri_iva';
        }
        if (nome === 'registro_prima_nota') {
          nome = 'prima_nota';
        }
        if (nome === 'registro_carico_scarico_rifiuti') {
          nome = 'registro_rifiuti';
        }
        obj[nome] = classe.value;
        return obj as IClassiDocumentali;
      }).reduce((acc, curr) => {
        return {...acc, ...curr};
      });

      // console.log('modificato', user);
      // console.log('differenze', diff($scope.users.user.classiDocumentali, user.classiDocumentali));

      user.last_differences = JSON.stringify({classiDocumentali: diff($scope.user.classiDocumentali, user.classiDocumentali)});

      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'confermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return user;
          },
          otherUpdate: true,
          diffs: () => {
            return user.last_differences;
          }
        }
      });

      setTimeout($scope.getUsersTypeaheadValues, 3000);

      $scope.user = undefined;
      $scope.classi = undefined;
      $scope.usersList = [];
    };
    // </editor-fold>
    // $scope.updateUser = () => {
    //   this.ArchiSmallServices.updateOtherUser()
    // }

  }
}

export const GestioneClassiDocumentaliComponent: ng.IComponentOptions = {
  template: require('./gestione-classi-documentali.html'),
  controller: GestioneClassiDocumentaliController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-classi-documentali/gestione-classi-documentali.ts